export default __webpack_public_path__ + "static/media/logo_facebook.fbfc5cca.svg";